import { render, staticRenderFns } from "./ConversationDialog.vue?vue&type=template&id=c62c6c14"
import script from "./ConversationDialog.vue?vue&type=script&lang=js"
export * from "./ConversationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c62c6c14')) {
      api.createRecord('c62c6c14', component.options)
    } else {
      api.reload('c62c6c14', component.options)
    }
    module.hot.accept("./ConversationDialog.vue?vue&type=template&id=c62c6c14", function () {
      api.rerender('c62c6c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/ConversationDialog.vue"
export default component.exports